import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/dog/testna_postaja/agregati";

export const fetchTestStationAnimals = createAsyncThunk(
  "test-station/animals/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/pregledZivali/page`,
        undefined,
        page,
        filter,
        sort,
        true
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const testStationAnimalsSlice = createSlice({
  name: "testStation",
  initialState: {
    animalsPage: null,
    error: null,
    isLoading: false,
    byId: {},
  },
  reducers: {
    resetTestStationAnimals(state) {
      state.animalsPage = null;
      state.error = null;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTestStationAnimals.fulfilled, (state, action) => {
        state.isLoading = false;
        state.animalsPage = action.payload;
        action.payload.content.forEach((animal) => {
          const animalId = animal.odkupZival?.zival?.id;
          if (animalId != null) {
            state.byId[animalId] = animal;
          }
        });
      })
      .addCase(fetchTestStationAnimals.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchTestStationAnimals.pending, (state, _action) => {
        state.isLoading = true;
        state.error = null;
      });
  },
});

export const { resetTestStationAnimals } = testStationAnimalsSlice.actions;
export default testStationAnimalsSlice.reducer;
